import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class Frui_qpbzPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { frui_qpbzPage,currentFrui_qpbz} = this.props.user;
     this.fetchList( frui_qpbzPage);
  }

  fetchList = (page,values) => {
    const {getFrui_qpbzList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getFrui_qpbzList(params);
  }

  getDataSource() {
    const { user } = this.props;
    const { frui_qpbzById, frui_qpbzList } = user;
    if (!frui_qpbzList) return [];
    return frui_qpbzList.map(id => frui_qpbzById[id]);
  }

  get listProps() {
    const { user,actions } = this.props
    const { getFrui_qpbzListPending,frui_qpbzTotal,frui_qpbzPage } = user
    const { deleteFrui_qpbz,chooseCurrentFrui_qpbz,frui_qpbzModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getFrui_qpbzListPending,
      columns:[
        {
          title: "开放平台应用",
          dataIndex: 'shopName',
          key: 'shopName',
          width: 180,
        },
      ],
      pagination:{
        total:frui_qpbzTotal,
        current:frui_qpbzPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentFrui_qpbz(record);
          frui_qpbzModalChange(true,"updata");
        }else if(item.key == 3){
            deleteFrui_qpbz(record.id).then((data) => {
            this.fetchList(frui_qpbzPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { user,actions } = this.props
    const { currentFrui_qpbz, frui_qpbzModalVisible,frui_qpbzPage, frui_qpbzModalType,submitFrui_qpbzPending } = user

    const { frui_qpbzModalChange,submitFrui_qpbz } = actions;
    const editItem  = frui_qpbzModalType === 'create' ? {} : currentFrui_qpbz
    return {
      item: frui_qpbzModalType === 'create' ? {} : currentFrui_qpbz,
      visible: frui_qpbzModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_qpbzPending,
      title: `${
        frui_qpbzModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "shopName",
          label: "商户名",
          // initialValue: editItem.shopName,
          widget: Input,
          required: true
        },
        {
          key: "score",
          label: "score",
          // initialValue: editItem.score,
          widget: Input,
          required: true
        },
        {
          key: "subAppid",
          label: "商户公众号id",
          // initialValue: editItem.subAppid,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitFrui_qpbz(Object.assign({},data,{})).then(data=> {
          frui_qpbzModalChange(false,"create");
          this.fetchList(frui_qpbzPage);
        })
      },
      onCancel() {
        frui_qpbzModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,user } = this.props
    const { currentFrui_qpbz,frui_qpbzPage} = user
    const { frui_qpbzModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入登录名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        frui_qpbzModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,user } = this.props
    const { currentFrui_qpbz,frui_qpbzPage} = user
    const { frui_qpbzModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ frui_qpbzModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_qpbzPage);


// WEBPACK FOOTER //
// ./src/features/user/Frui_qpbzPage.js